export const CATEGORY_TYPE = {
  ALL: 'All',
  RANDOM: 'Random'
}

export const THEME = {
  LIGHT: 'light',
  DARK: 'dark',
}
